import type { Namespace, NamespaceFile, NamespaceFileUrl } from './types.js';

export const salesforce: Namespace = import.meta.glob<NamespaceFile>(
    '../locales/*/salesforce.json' satisfies NamespaceFileUrl,
    { eager: true, import: 'default' },
);
